const SearchParams = Object.freeze({
    HIDE_REGISTRATION: 'hideRegistration',
    ESIG: 'esig',
    ERROR_ID: 'error_id',
    ERROR_TIMESTAMP: 'error_timestamp',
    ERROR_TYPE: 'errorType',
    REQUEST_ID: 'requestId',
    NOTIFICATION_TOKEN: 'notificationToken',
});

export default SearchParams;
